module.exports = __webpack_public_path__ + "img/down-triangle-lines-plus.ea10e35f.svg";